import crypto from 'crypto';

export const createParticipantEntryId = (scheduledSessionId: string, participantId: string) => {
  return crypto.createHash('SHA1').update([scheduledSessionId, participantId].join('-')).digest('hex');
}